import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    tooManyOpenTabsTitle: translate({ id: 'loader.tooManyTabsOpen.title' }),
    tooManyOpenTabsSubtitle: translate({ id: 'loader.tooManyTabsOpen.subtitle' }),
  }))

  return api
}
